export enum FlagTriggerType {
  Voluntary = 'Voluntary',
  Involuntary = 'Involuntary',
}

export enum FlagReason {
  JobOfferPackage = 'Job offer package',
  ProjectDepartmentV = 'Project/Department (V)',
  Personal = 'Personal',
  Relocation = 'Relocation',
  ProjectDepartmentI = 'Project/Department (I)',
  Performance = 'Performance',
  CulturalMismatch = 'Cultural Mismatch',
  PassedAway = 'Passed Away',
  None = 'None',
}

export enum FlagSubreason {
  Compensation = 'Compensation',
  ContractConditions = 'Contract Conditions',
  TechnologyStack = 'Technology Stack',
  ContentTasks = 'Content (Tasks)',
  LeadTeam = 'Lead / Team',
  ProfessionalDevelopment = 'Professional Development',
  ClientDepartment = 'Client/ Department',
  OwnBusinessStudies = 'Own Business / Studies',
  Health = 'Health',
  MilitaryService = 'Military service',
  BudgetIssues = 'Budget issues',
  EndProject = 'End of the project',
  VisaSponsorship = 'Visa sponsorship',
  PersonalOrProfessional = 'Personal / Professional',
  JobAbandonment = 'Job Abandonment',
  ClientMismatch = 'Client Mismatch',
  HardSkills = 'Hard Skills',
  SoftSkills = 'Soft Skills',
  LegalCompliance = 'Legal Compliance',
  HardAndSoftSkills = 'Hard and soft skills',
  DirectHireConversion = 'Direct Hire Conversion',
}
